import React, { useState } from 'react'
import TableGroup from './TableGroup'
import SubscriptionCard from './SubscriptionCard'
import { ContentfulEntry, CurrencyExchangeRate, SubscriptionType, SubscriptionTypes } from '../Page'
import StartBuildingButton from '../../../../../components/assembly_card/StartBuildingButton'

interface Props {
  contentfulEntry: ContentfulEntry
  currencyExchangeRate: CurrencyExchangeRate
}

const TieredPlans: React.FC<Props> = ({ contentfulEntry, currencyExchangeRate }) => {
  const [showTable, setShowTable] = useState(false)

  const fetchSubscriptionType = (index: number): SubscriptionType => {
    switch (index) {
      case 0:
        return SubscriptionTypes.Freemium
      case 1:
        return SubscriptionTypes.Pro
      case 2:
        return SubscriptionTypes.Business
      case 3:
        return SubscriptionTypes.Enterprise
      default:
        return SubscriptionTypes.Freemium
    }
  }

  return (
    <div>
      <div className='subscriptions-pricing__tiered-plans'>
        <div>
          <div className='subscriptions-pricing__tiered-plans-card'>
            <img
              className='subscriptions-pricing__tiered-plans-card-icon'
              src='https://assets.vention.io/page-assets/subscriptions/icons/gripper.svg'
              alt={contentfulEntry.tieredPlansTitle}
            />
            <h2 className='subscriptions-pricing__tiered-plans-card-title'>
              {contentfulEntry.tieredPlansTitle}
            </h2>
            <p className='subscriptions-pricing__tiered-plans-card-description'>
              {contentfulEntry.tieredPlansDescription}
            </p>
          </div>
        </div>
        {contentfulEntry.tieredPlansPricingCards?.map((subscriptionCardProps, index) => (
          <SubscriptionCard
            key={index}
            currencyExchangeRate={currencyExchangeRate}
            showTable={showTable}
            setShowTable={setShowTable}
            subscriptionType={fetchSubscriptionType(index)}
            tableGroupsProps={contentfulEntry.tieredPlansTableGroups}
            {...subscriptionCardProps}
          />
        ))}
      </div>
      {showTable && (
        <div className='subscriptions-pricing__tiered-plans-table'>
          <div className='subscriptions-pricing__tiered-plans-table-column subscriptions-pricing__tiered-plans-table-column--hide-icons'>
            {contentfulEntry.tieredPlansTableGroups?.map((tableGroupProps, index) => (
              <TableGroup key={index} {...tableGroupProps} desktop />
            ))}
          </div>
        </div>
      )}
      {showTable && (
        <div className='subscriptions-pricing__tiered-plans-footer-links'>
          <div></div>
          {contentfulEntry.tieredPlansPricingCards.map((item, index) =>
            item.linkPrimaryToNewDesign ? (
              <StartBuildingButton
                key={index}
                label={item.linkPrimaryLabel}
                className='subscriptions-pricing__subscription-card-link'
              />
            ) : (
              <a
                key={index}
                className='subscriptions-pricing__subscription-card-link'
                href={item.linkPrimaryUrl}
              >
                {item.linkPrimaryLabel}
              </a>
            )
          )}
        </div>
      )}
    </div>
  )
}

export default TieredPlans
